import { Text } from 'components'
import { theme } from 'styles/theme/hav-theme'

export type SubrowItemProps = {
  log?: string | null
}

export const SubrowItem = ({ log }: SubrowItemProps) => {
  if (!log) return null

  return (
    <Text customColor={theme.colors.ion.neutral.strong} size="xs">
      {log}
    </Text>
  )
}
